import { useRef } from 'react';
import { useGridFilter } from 'ag-grid-react';
import { Form } from 'antd';

import { createFilterComponent } from '../create-data-grid-filter';
import {
  createRangeDateFilterModel,
  RangeDateFilterModel,
  RangeDateFilterParams,
} from './core';
import { RangeDateFilterForm } from './range-date-filter.form';

export const RangeDateFilterComponent = createFilterComponent<
  RangeDateFilterModel,
  RangeDateFilterParams
>(({ onModelChange, model, filterParams }) => {
  const { closeWhenChanged, filterName } = filterParams;
  const shouldClosePopupAfterChange = closeWhenChanged ?? true;
  const hidePopupRef = useRef<(() => void) | undefined>(() => {});
  const hidePopup = () => hidePopupRef.current?.();

  const [form] = Form.useForm();

  useGridFilter({
    // use for disable client-side filtering
    doesFilterPass: () => true,
    afterGuiAttached: (params) => {
      hidePopupRef.current = params?.hidePopup;
    },
  });

  const onSubmit = (value: RangeDateFilterModel['value']) => {
    const model = createRangeDateFilterModel({
      value,
      filterName,
    });

    onModelChange(model);

    if (shouldClosePopupAfterChange) hidePopup();
  };

  const onReset = () => {
    form.resetFields();
    onModelChange(null);

    if (shouldClosePopupAfterChange) hidePopup();
  };

  return (
    <RangeDateFilterForm
      form={form}
      value={model?.value}
      onSubmit={onSubmit}
      onReset={onReset}
    />
  );
});

export type RangeDateFilterComponent = typeof RangeDateFilterComponent;
